<template>
<div>
  <Banner
    style="background-color: #d5d5d5;"
    class="sticky-top"
    />
  <b-container class="my-5 p-5">
    <b-row>
      <b-col class="mt-0 pt-0 mb-5 pb-5 vh-100">
	<div class="text-center">
	  <img src="../assets/trinity_404_icon.png" height="120" alt="404 error"/>
	  <h1>404 Error: Page not found</h1>
	</div>
	<br>
	<br>
      </b-col>
    </b-row>
  </b-container>
  <footerNav/>
</div>
</template>

<script>
import Banner from '@/components/gmx-banner.vue';
import footerNav from '@/components/footer.vue';
export default {
    name: "NotFound",
    components: {
	Banner,
	footerNav
    }
}
</script>
